/* this logic is borrowed from Help-Support/help-support-web */
const generateUUID = () => {
  const regex = /[xy]/g;
  let d = Date.now();
  let r;

  const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(regex, (c) => {
    r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });

  window.sessionStorage.setItem("uuid", uuid);
  return uuid;
};

export const uuid = window.sessionStorage.getItem("uuid") || generateUUID();
